const ParkingIcon = props => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_301_683)">
      <path
        d="M13.5417 3.125H6.25V21.875H10.4167V15.625H13.5417C16.9896 15.625 19.7917 12.8229 19.7917 9.375C19.7917 5.92708 16.9896 3.125 13.5417 3.125ZM13.75 11.4583H10.4167V7.29167H13.75C14.8958 7.29167 15.8333 8.22917 15.8333 9.375C15.8333 10.5208 14.8958 11.4583 13.75 11.4583Z"
        fill="#3982C2"
      />
    </g>
    <defs>
      <clipPath>
        <rect width={25} height={25} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default ParkingIcon
